import { reactive, ref } from "vue";
import { queryMaterielList } from "@/api/materiel";
import { queryDictList } from "@/api/dict";
import { DICT_KEY } from "@/constants/dict";
import { ElMessageBox, ElMessage } from "element-plus";
import { postDownload } from "@/utils";

export default function useManageTable() {
  // 搜索条件
  const searchData = reactive({
    name: "",
    code: "",
    categoryId: "",
    brand: "",
    model: "",
    creator: "",
    createTime: "",
  });

  // 搜索条件ref
  const searchRef = ref(null);

  // 导入ref
  const uploadRef = ref(null);

  // 表格配置
  const columns = ref([
    {
      label: "物料名称",
      prop: "name",
    },
    {
      label: "物料编号",
      prop: "number",
    },
    {
      label: "类别",
      prop: "categoryName",
    },
    {
      label: "品牌",
      prop: "brand",
    },
    {
      label: "规格型号",
      prop: "model",
    },
    {
      label: "单位",
      prop: "unit",
    },
    {
      label: "供应商",
      prop: "supplier",
    },
    {
      label: "创建人",
      prop: "createName",
    },
    {
      label: "创建时间",
      prop: "createTime",
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 分页参数
  const pageParams = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 品牌列表
  const brandList = ref([]);

  // 规格型号列表
  const modelList = ref([]);

  // 导入参数
  const uploadConfig = reactive({
    templateUrl: "/material/download", // 模板下载的url
    name: "物料导入模板.xlsx", // 模板文件名
  });

  // 获取表格数据
  const getList = () => {
    tableLoading.value = true;
    queryMaterielList({
      ...searchData,
      createStartTime: searchData.createTime[0],
      createEndTime: searchData.createTime[1],
      page: pageParams.page,
      limit: pageParams.limit,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pageParams.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };

  // 点击导入
  const handleUpload = () => {
    uploadRef.value?.handleDialogOpen();
  };

  // 点击导出
  const handleDownload = () => {
    ElMessageBox.confirm("确定导出物料类别数据吗?", "导出", {
      confirmButtonText: "导出",
      cancelButtonText: "取消",
      type: "success",
    })
      .then(() => {
        postDownload("/material/export", {}, "物料管理.xlsx");
      })
      .catch(() => {
        ElMessage.info("已取消");
      });
  };

  // 获取字典数据
  const getDictList = () => {
    queryDictList(DICT_KEY["brand"]).then((res) => {
      brandList.value = res.data || [];
    });
    queryDictList(DICT_KEY["model"]).then((res) => {
      modelList.value = res.data || [];
    });
  };

  return {
    searchData,
    searchRef,
    columns,
    tableData,
    tableLoading,
    pageParams,
    brandList,
    modelList,
    uploadConfig,
    uploadRef,
    getList,
    handleReset,
    handleUpload,
    handleDownload,
    getDictList,
  };
}
